import { createStyles, makeStyles, Theme } from "@material-ui/core";
import Modal, { DefaultModalProps } from "app/components/Modal";
import React, { memo } from "react";
import warning_icon from 'assets/img/warning.svg';
import ButtonLoader from "app/components/ButtonLoader";

const TimeToUpgradeModal = memo(({state}: DefaultModalProps) => {
    const classes = useStyles();

    const onClick = () => state[1](false)

    return <Modal state={state} dialogClassname={classes.modal}>
        <div className={classes.content}>
            <h2 className={classes.header}>Its time to upgrade.</h2>
            <img src={warning_icon} className={classes.icon}/>
            <p className={classes.pharagraph}>
                Your 90 days free Premium account has ended<br/>
                To still enjoy real-time deposit, upgrade to Premium
            </p>
        </div>
        <ButtonLoader text="Continue" style={`filled blue ${classes.button}`} onClick={onClick}/>
    </Modal>
})

const useStyles = makeStyles((theme: Theme) => 
    createStyles({
        modal: {
            borderRadius: "5px!important",
            fontFamily: "Arial",
            textAlign: "center",
            letterSpacing: "-0.2px",
            ["& > .modal"]: {
                padding: "40px"
            }
        },
        header: {
            fontSize: "33px",

        },
        icon: {
            width: "100px",
            marginBottom: "30px"
        },
        pharagraph: {
            marginBottom: "30px"
        },
        button: {
            marginBottom: 0
        },
        content: {
            padding: "10px 20px"
        }
    })
)

export default TimeToUpgradeModal